<!--后台网站框架-->
<template>
  <div class="tmpl_IndexPage">
    <div class="wrapper">
      <comHeader ref='comHeaderRef' :userName="userName"></comHeader>
    </div>
    <!--
    <keep-alive>
      <router-view v-wechat-title="$route.meta.title"/>
    </keep-alive>
!-->
    <router-view v-wechat-title="$route.meta.title" v-if="ifRouterAlive"/>
    <div id="toTop" class="VerticalMid">
      <el-tooltip class="item" effect="dark" content="返回顶部" placement="top">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#fax-font-top-o"></use>
        </svg>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
  import '@/assets/css/Student.css';
  import comHeader from '@/components/Student/Header.vue';

  export default {
    components: {
      comHeader
    },
    // 用于刷新子页面方法
    provide(){
      return{
        reload:this.reload
      }
    },
    data() {
      return {
        activeIndex: '1',
        userName: null,
        ifRouterAlive:true,
      };
    },
    created() {
      let that = this;
      that.userName = JSON.parse(that.$GetKey(that.$cacheStudent)).name + " / " + JSON.parse(that.$GetKey(that.$cacheStudent)).studentNo;
      if(that.$route.query.editpwd == 'true'){
        that.$confirm('本次登录使用的是默认密码，为了保障账号安全，建议尽快修改密码。', '提示', {
          confirmButtonText: '前往修改',
          cancelButtonText: '稍后修改',
          closeOnClickModal:false,
          'showClose':false,
          type: 'warning'
        }).then(() => {
          console.log(that.$refs.comHeaderRef)
          if(that.$refs.comHeaderRef){
            that.$refs.comHeaderRef.handleCompanyChange('修改密码');
          }
        }).catch(() => {
          let query = {}
          for(let key in this.$route.query){
            if(key != 'editpwd'){
              query[key] = this.$route.query[key]
            }
          }
          this.$router.push({
            path: this.$route.path,
            query
          })
        });

      }
    },
    methods: {
      /**
       * @description 刷新子页面方法
       */
      reload(){
        let that=this;
        that.ifRouterAlive=false;
        that.$nextTick(()=>{
          that.ifRouterAlive=true;
        })
      },
      handleSelect(key, keyPath) {

      }
    },
    mounted() {
      let that=this;
      $(window).scroll(function() {
        if ($(this).scrollTop() != 0) {
          $("#toTop").fadeIn();
        } else {
          $("#toTop").fadeOut();
        }
      });

      $("#toTop").click(function() {
        $("body,html").animate({
          scrollTop: 0,
        }, 800);
      });

    },
  };



</script>

<style scoped="scoped">
  #toTop {
    position: fixed;
    right: 10px;
    bottom: 10px;
    z-index: 99;
    display: none;
    padding: 2px 8px;
    cursor: pointer;
    background-color: #F7F7F7;
    color: #444444;
    border: 1px solid #DDDDDD;
    font-size: 26px;
    border-radius: 5px;
  }

  #toTop:hover {
    background-color: #007BFF;
    color: #FFFFFF;
    border-color: #007BFF;
  }
</style>
